import { Injectable } from '@angular/core';
import { Food } from 'src/app/model/Food';
import { url } from 'inspector';
import {HttpClient, HttpHeaders, HttpParameterCodec, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
// import { encodeUriFragment } from '@angular/router/src/url_tree';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FatsecretManagerService {

  clientID = "ee674f1dc3764861900ccd18a318a170";
  clientSecret = "879f79b035ef4cee9434b481b30953a7";

  consumerKey = "7a1f012ef2764d71bf13b7ef5a2a0f02";
  consumerSecret = "68762470d1074905a9afa377b17c0f35&";

  // consumerKey = "7810c607cea043a7ad48ad6cfb1ada31";
  // consumerSecret = "ff489c3ec7284fedbc14a65cf84a219b&";
  oauth_signature_method = "HMAC-SHA1";
  oauth_version = "1.0";

  constructor(
    private http: HttpClient,
   ) {
    //  this.getAccessToken().subscribe((data) => {
    //     console.log('token' + data);
    //  });
  }

  public getAccessToken(): Observable<any> {
    console.log('getting access token')
    const url = 'https://oauth.fatsecret.com/connect/token';
    // url = encodeURIComponent(url);
    const httpOptions = {
      auth: {
        user: this.clientID,
        password: this.clientSecret
      },
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      form: {
        'grant-type': 'client_credentials',
        'scope': 'basic'
      },
      json: true
    };

    return this.http.post<any>(url, {}, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  // FIX THE SIGNATURE
  public searchFood(foodName: string) : Observable <any> {

    const d = new Date();
    let nonce = '';

    let reqObj = {
      format: 'json',
      method: 'foods.search',
      oauth_consumer_key: this.consumerKey,
      oauth_nonce: Math.random().toString(36).replace(/[^a-z]/, '').substr(2),
      oauth_signature_method: 'HMAC-SHA1',
      oauth_timestamp: Math.floor(d.getTime() / 1000),
      oauth_version: '1.0',
      search_expression: encodeURIComponent(foodName)
    };

    var paramStr = "";
    for (var i in reqObj) {
      console.log(reqObj[i]);
      if (i == "oauth_nonce") {
        nonce = reqObj[i];
      }
      paramStr += "&" + i + "=" + reqObj[i];
    }

    console.log(nonce);

    paramStr = paramStr.substr(1);

    var sigBaseStr = "POST&" + encodeURIComponent('https://platform.fatsecret.com/rest/server.api')
                      + "&" 
                      + encodeURIComponent(paramStr);
    console.log("base " + sigBaseStr);

    var osig = CryptoJS.HmacSHA1(sigBaseStr, this.consumerSecret);
    var osig_base64 = CryptoJS.enc.Base64.stringify(osig);
    var osig_base64_enc = encodeURIComponent(osig_base64);
    console.log("sig = " + osig_base64_enc);
    var time = new Date().getTime();
    time = Math.floor(time / 1000);

    var url = '/rest/server.api?format=json&method=foods.search&search_expression=' + encodeURIComponent(foodName) + '&oauth_consumer_key='
              + this.consumerKey + '&oauth_signature_method=HMAC-SHA1&oauth_timestamp=' + time + '&oauth_nonce=' + nonce + 
              '&oauth_version=1.0' + '&oauth_signature=' + osig_base64_enc;

    const httpOptions = {
     headers : new HttpHeaders({
      'cache-control': 'no-cache',
      Connection: 'keep-alive',
      'Content-Length': '',
      'Accept-Encoding': 'gzip, deflate',
      Host: 'platform.fatsecret.com',
      'Cache-Control': 'no-cache',
      Accept: '*/*',
      'Content-Type': 'application/json'
     })
    }
    
    console.log('https://platform.fatsecret.com' + url);
    return this.http.post<any>(url, httpOptions);
  }
  
  public getFoodInfo(foodId: string) : Observable <any> {

    const d = new Date();
    var nonce = "";

    var reqObj = {
      food_id: foodId,
      format: 'json',
      method: 'food.get',
      oauth_consumer_key: this.consumerKey,
      oauth_nonce: Math.random().toString(36).replace(/[^a-z]/, '').substr(2),
      oauth_signature_method: 'HMAC-SHA1',
      oauth_timestamp: Math.floor(d.getTime() / 1000),
      oauth_version: '1.0',
    };

    var paramStr = "";
    for (var i in reqObj) {
      if (i == "oauth_nonce") {
        nonce = reqObj[i];
      }
      paramStr += "&" + i + "=" + reqObj[i];
    }

    paramStr = paramStr.substr(1);

    var sigBaseStr = "POST&" + encodeURIComponent('https://platform.fatsecret.com/rest/server.api')
                      + "&" 
                      + encodeURIComponent(paramStr);

    var osig = CryptoJS.HmacSHA1(sigBaseStr, this.consumerSecret);
    var osig_base64 = CryptoJS.enc.Base64.stringify(osig);
    var osig_base64_enc = encodeURIComponent(osig_base64);
    // var hashedBaseStr = crypto.createHmac('sha1', this.consumerSecret).update(sigBaseStr).digest('base64');
    var time = new Date().getTime();
    time = Math.floor(d.getTime() / 1000);

    var url = '/rest/server.api?format=json&method=food.get&food_id=' + foodId + '&oauth_consumer_key='
              + this.consumerKey + '&oauth_signature_method=HMAC-SHA1&oauth_timestamp=' + time + '&oauth_nonce=' + nonce + 
              '&oauth_version=1.0' + '&oauth_signature=' + osig_base64_enc;
    //  url = environment.baseURL + url;

    const httpOptions = {
      headers : new HttpHeaders({
        'cache-control': 'no-cache',
        Connection: 'keep-alive',
        'Content-Length': '',
        'Accept-Encoding': 'gzip, deflate',
        Host: 'platform.fatsecret.com',
        'Cache-Control': 'no-cache',
        Accept: '*/*',
        'Content-Type': 'application/json'
       })
    }
    return this.http.post<any>(url, httpOptions);

  }    

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(
      'Something bad happened; please try again later.');
  };
}
